/**
 * @generated SignedSource<<984b5658acc3751d39222f63c90c0543>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Support_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeatureFlag_user">;
  readonly " $fragmentType": "Support_user";
};
export type Support_user$key = {
  readonly " $data"?: Support_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Support_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Support_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeatureFlag_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "afd148a4ca5c3efb26b9745355024ed5";

export default node;
